module.exports = __webpack_public_path__ + "img/card_activities_record.587f1fd9.png";